<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("ventasPorRangoDeMesas") }}</template>
      </breadcrumb>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="false"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta && !pantallaDetalle">
        <template v-if="list.length > 0">
          <div class="row justify-content-between div-export ">
            <div class="col-md-12  text-left">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span>
                      {{ $t("nombre") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenacionnumComensales"
                      @click="
                        sort('numComensales'), (ordenacionnumComensales = 0)
                      "
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("numeroDeComensales") }}</span
                    >
                    <span
                      v-else
                      @click="
                        sort('numComensales'), (ordenacionnumComensales = 1)
                      "
                    >
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("numeroDeComensales") }}</span
                    >
                  </th>
                  <th>
                    <span
                      v-if="ordenacionnumOperaciones"
                      @click="
                        sort('numOperaciones'), (ordenacionnumOperaciones = 0)
                      "
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("numeroDeOperaciones") }}</span
                    >
                    <span
                      v-else
                      @click="
                        sort('numOperaciones'), (ordenacionnumOperaciones = 1)
                      "
                    >
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("numeroDeOperaciones") }}</span
                    >
                  </th>
                  <th>
                    <span
                      v-if="ordenacionVentas"
                      @click="sort('ventas'), (ordenacionVentas = 0)"
                    >
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("ventas") }}</span
                    >
                    <span v-else @click="sort('ventas'), (ordenacionVentas = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("ventas") }}</span
                    >
                  </th>
                  <th
                    v-if="ordenacionPrecioMedioComensales === 0"
                  >
                  <!-- @click="sortedArrayPrecioMedioComensalesASC()"
                    <i style="color: white" class="fa fa-angle-up"></i> -->
                    {{ $t("precioMedioPorComensal") }}
                  </th>
                  <th v-else>
                      <!-- @click="sortedArrayPrecioMedioComensalesDESC()"
                    <i style="color: white" class="fa fa-angle-down"></i> -->
                    {{ $t("precioMedioPorComensal") }}
                  </th>
                  <th
                    v-if="ordenacionPrecioMedioOperaciones === 0"
                  >
                  <!-- @click="sortedArrayPrecioMedioOperacionesASC()"
                    <i style="color: white" class="fa fa-angle-up"></i> -->
                    {{ $t("precioMedioPorOperacion") }}
                  </th>
                  <th v-else>
                      <!-- @click="sortedArrayPrecioMedioOperacionesDESC()"
                    <i style="color: white" class="fa fa-angle-down"></i> -->
                    {{ $t("precioMedioPorOperacion") }}
                  </th>
                  <th>
                    {{ $t("detalles") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in sorted">
                  <td align="left">{{ obj.nombre }}</td>
                  <td align="right">{{ obj.numComensales }}</td>
                  <td align="right">{{ obj.numOperaciones }}</td>
                  <td align="right">{{ obj.ventas | currency }}</td>
                  <td align="center" v-if="obj.numComensales === 0">-</td>
                  <td align="right" v-else>
                    {{ (obj.ventas / obj.numComensales) | currency }}
                  </td>
                  <td align="center" v-if="obj.numOperaciones === 0">-</td>
                  <td align="right" v-else>
                    {{ (obj.ventas / obj.numOperaciones) | currency }}
                  </td>
                  <td v-if="obj.numOperaciones > 0" @click="mostrarDetalles(obj.idRango)" align="center">
                    <i style="color: black" class="fas fa-arrow-circle-right"></i>
                  </td>
                  <td v-else align="center">
                    <span>-</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalComensales }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalOperaciones }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalVentas | currency }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalPrecioMedComensales | currency }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalPrecioMedOperacion | currency }}</strong>
                  </td>
                  <td class="text-center">
                    <strong>-</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHay") }} <strong>{{ $t("ventasMinusculas") }} </strong>
            {{ $t("rangoDeFechas") }}
          </div>
        </template>
      </div>
      
      <div class="col-md-12" v-else-if="pantallaDetalle && respuesta">
        <template>
          <div class="row justify-content-between div-export">
            <div class="col-md-12" style="text-align: center">

              <button @click="cerrarDetalles()" type="button" class="btn btn-outline-link btnVolver">
                <i class="fas fa-arrow-circle-left"></i>
                {{ $t("volver") }}
              </button>

              <span><strong>{{ listDetalles[0].nombre }}</strong></span>

              <!-- Pendiente export de detalles -->
              <!--<el-dropdown style="float: right">
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>-->

            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span>
                      {{ $t("mesa") }}
                    </span>
                  </th>
                  <th>
                    <span>
                      <!--<i style="color: white" class="fa fa-angle-up"></i>-->
                      {{ $t("numeroDeComensales") }}
                    </span>
                  </th>
                  <th>
                    <span>
                      <!--<i style="color: white" class="fa fa-angle-up"></i>-->
                      {{ $t("numeroDeOperaciones") }}</span
                    >
                  </th>
                  <th>
                    <span>
                      <!--<i style="color: white" class="fa fa-angle-up"></i>-->
                      {{ $t("ventas") }}</span
                    >
                  </th>
                  <th
                    v-if="ordenacionPrecioMedioComensalesDetalles === 0"
                  >
                  <!-- @click="sortedArrayPrecioMedioComensalesASC()"
                    <i style="color: white" class="fa fa-angle-up"></i> -->
                    {{ $t("precioMedioPorComensal") }}
                  </th>
                  <th v-else>
                      <!-- @click="sortedArrayPrecioMedioComensalesDESC()"
                    <i style="color: white" class="fa fa-angle-down"></i> -->
                    {{ $t("precioMedioPorComensal") }}
                  </th>
                  <th
                    v-if="ordenacionPrecioMedioOperacionesDetalles === 0"
                  >
                  <!-- @click="sortedArrayPrecioMedioOperacionesASC()"
                    <i style="color: white" class="fa fa-angle-up"></i> -->
                    {{ $t("precioMedioPorOperacion") }}
                  </th>
                  <th v-else>
                      <!-- @click="sortedArrayPrecioMedioOperacionesDESC()"
                    <i style="color: white" class="fa fa-angle-down"></i> -->
                    {{ $t("precioMedioPorOperacion") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="objDet in listDetalles">
                  <td align="left">{{ objDet.numMesa }}</td>
                  <td align="right">{{ objDet.numComensales }}</td>
                  <td align="right">{{ objDet.numOperaciones }}</td>
                  <td align="right">{{ objDet.ventas | currency }}</td>
                  <td align="center" v-if="objDet.numComensales === 0">-</td>
                  <td align="right" v-else>
                    {{ (objDet.ventas / objDet.numComensales) | currency }}
                  </td>
                  <td align="center" v-if="objDet.numOperaciones === 0">-</td>
                  <td align="right" v-else>
                    {{ (objDet.ventas / objDet.numOperaciones) | currency }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalComensalesDetalles }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalOperacionesDetalles }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalVentasDetalles | currency }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalPrecioMedComensalesDetalles | currency }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalPrecioMedOperacionDetalles | currency }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Loading,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import Datetime from "vue-datetime";
import moment from "moment";
import { mapState } from "vuex";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });

    this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorRangoDeMesas"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Datetime]: Datetime,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      idBusiness: 0,
      idTpv: 0,
      listBusinesses: [],
      listTpv: [],
      list: ["-"],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      //ORDENAR
      currentSort: "nombre",
      currentSortDir: "asc",
      ordenacionPrecioMedioComensales: 0,
      ordenacionPrecioMedioOperaciones: 0,
      ordenacionFecha: 0,
      ordenacionnumComensales: 0,
      ordenacionnumOperaciones: 0,
      ordenacionVentas: 0,

      //ORDENAR DETALLES
      currentSortDetalles: "numMesa",
      currentSortDirDetalles: "asc",
      ordenacionPrecioMedioComensalesDetalles: 0,
      ordenacionPrecioMedioOperacionesDetalles: 0,
      ordenacionFechaDetalles: 0,
      ordenacionnumComensalesDetalles: 0,
      ordenacionnumOperacionesDetalles: 0,
      ordenacionVentasDetalles: 0,

      respuesta: true,

      //DETALLES

      pantallaDetalle: false,
      listDetalles: [],
      retail:true,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    sorted: function() {
      return this.list.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },

    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/rangosMesas/exportVentasRangoMesas/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/rangosMesas/exportVentasRangoMesas/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    getTotalVentas() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.ventas;
      });
      return total;
    },

    getTotalVentasDetalles() {
      let total = 0;
      this.listDetalles.forEach(function(d) {
        total += d.ventas;
      });
      return total;
    },

    getTotalPrecioMedComensales() {
      let total = 0;
      let ventas = 0;
      let numComensales = 0;
      this.list.forEach(function(d) {
        if (d.numComensales !== 0) {
          ventas += d.ventas;
          numComensales += d.numComensales;
        }
      });

      total = ventas / numComensales;
      return total;
    },

    getTotalPrecioMedComensalesDetalles() {
      let total = 0;
      let ventas = 0;
      let numComensales = 0;
      this.listDetalles.forEach(function(d) {
        if (d.numComensales !== 0) {
          ventas += d.ventas;
          numComensales += d.numComensales;
        }
      });

      total = ventas / numComensales;
      return total;
    },

    getTotalPrecioMedOperacion() {
      let total = 0;
      let ventas = 0;
      let numOperaciones = 0;
      this.list.forEach(function(d) {
        if (d.numOperaciones !== 0) {
          ventas += d.ventas;
          numOperaciones += d.numOperaciones;
        }
      });

      total = ventas / numOperaciones;
      return total;
    },

    getTotalPrecioMedOperacionDetalles() {
      let total = 0;
      let ventas = 0;
      let numOperaciones = 0;
      this.listDetalles.forEach(function(d) {
        if (d.numOperaciones !== 0) {
          ventas += d.ventas;
          numOperaciones += d.numOperaciones;
        }
      });

      total = ventas / numOperaciones;
      return total;
    },

    getTotalComensales() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.numComensales;
      });
      return total;
    },

    getTotalComensalesDetalles() {
      let total = 0;
      this.listDetalles.forEach(function(d) {
        total += d.numComensales;
      });
      return total;
    },

    getTotalOperaciones() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.numOperaciones;
      });
      return total;
    },

    getTotalOperacionesDetalles() {
      let total = 0;
      this.listDetalles.forEach(function(d) {
        total += d.numOperaciones;
      });
      return total;
    },
  },

  methods: {
    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            vm.idTpv = response.data.result[0].id;
            if (vm.listTpv.length > 0) {
              vm.getVentasRangoMesas();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.list = [];
      this.retail = true;
      this.getConfigTpvRetail();
      this.getTpv();
    },
    emitirConsulta() {
      if (!this.retail) {
        swal({
          title: "Negocio tipo RETAIL",
          text: "Esta información no esta disponible para su modelo de negocio",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "info",
        });
      }
      this.getVentasRangoMesas();
    },
    cambioTpv(idTpvData, filtrar) {

      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }
      
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    cerrarDetalles() {
      this.pantallaDetalle = false;
    },
    sortedArrayPrecioMedioComensalesASC: function() {
      this.ordenacionPrecioMedioComensales = 1;

      function compare(a, b) {
        if (a.numComensales === 0 && b.numComensales === 0) {
          return -1;
        } else if (a.numComensales !== 0 && b.numComensales === 0) {
          return 1;
        } else if (a.numComensales === 0 && b.numComensales !== 0) {
          return -1;
        } else {
          if (a.ventas / a.numComensales < b.ventas / b.numComensales) return -1;
          if (a.ventas / a.numComensales > b.ventas / b.numComensales) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },
    sortedArrayPrecioMedioComensalesDESC: function() {
      this.ordenacionPrecioMedioComensales = 0;

      function compare(a, b) {
        if (a.numComensales === 0 && b.numComensales === 0) {
          return 1;
        } else if (a.numComensales !== 0 && b.numComensales === 0) {
          return -1;
        } else if (a.numComensales === 0 && b.numComensales !== 0) {
          return 1;
        } else {
          if (a.ventas / a.numComensales > b.ventas / b.numComensales) return -1;
          if (a.ventas / a.numComensales < b.ventas / b.numComensales) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },
    sortedArrayPrecioMedioOperacionesASC: function() {
      this.ordenacionPrecioMedioOperaciones = 1;

      function compare(a, b) {

        if (a.numOperaciones === 0 && b.numOperaciones === 0) {
          return -1;
        } else if (a.numOperaciones !== 0 && b.numOperaciones === 0) {
          return 1;
        } else if (a.numOperaciones === 0 && b.numOperaciones !== 0) {
          return -1;
        } else {
          if (a.ventas / a.numOperaciones < b.ventas / b.numOperaciones) return -1;
          if (a.ventas / a.numOperaciones > b.ventas / b.numOperaciones) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },
    sortedArrayPrecioMedioOperacionesDESC: function() {
      this.ordenacionPrecioMedioOperaciones = 0;

      function compare(a, b) {
        if (a.numOperaciones === 0 && b.numOperaciones === 0) {
          return 1;
        } else if (a.numOperaciones !== 0 && b.numOperaciones === 0) {
          return -1;
        } else if (a.numOperaciones === 0 && b.numOperaciones !== 0) {
          return 1;
        } else {
          if (a.ventas / a.numOperaciones > b.ventas / b.numOperaciones) return -1;
          if (a.ventas / a.numOperaciones < b.ventas / b.numOperaciones) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },

    sort: function(s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },

    sortDet: function(s) {
      if (s === this.currentSortDetalles) {
        this.currentSortDirDetalles = this.currentSortDirDetalles === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();
          vm.getConfigTpvRetail();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getConfigTpvRetail() {
      var config = {
          params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 84,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            
              vm.retail = false;

              swal({
                title: "Negocio tipo RETAIL",
                text: "Esta información no esta disponible para su modelo de negocio",
                confirmButtonClass: "btn btn-info btn-fill",
                type: "info",
              });

          }else{
            vm.retail = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getVentasRangoMesas() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "rangosMesas/getSalesByRangoMesas",
              config
            )
            .then(function(response) {
              if ( response.data.result.data.length > 0) {
                vm.list = response.data.result.data;

                vm.respuesta = true;
                vm.pantallaDetalle = false;

              }else if (response.data.response === false && response.data.rangoMayor === true) {
                    swal({
                      title: "Lo sentimos",
                      text: response.data.message,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "info",
                    });
                    vm.respuesta = false;
              } else { 
                vm.respuesta = false;

                if(vm.retail && vm.permiso){
                  swal({
                    title: vm.$t('noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: vm.$t('siCrearUnRangoMesas'),
                    cancelButtonText: vm.$t('cancelar'),
                    buttonsStyling: true
                  }).then((result) => {
                    if (result.value) {
                      vm.$router.push({
                        name: 'rangos-de-mesas',
                      })
                    }
                  });
                }
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    mostrarDetalles(idRango) {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: this.idTpv,
          datefrom: moment(this.datefrom)
            .startOf("day")
            .unix(),
          dateto: moment(this.dateto)
            .endOf("day")
            .unix(),
          idRango: idRango,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      }

      let vm = this;
        this.$store.dispatch("setIdBusiness", this.idBusiness);
        this.axios
          .get(
            this.$store.getters.apiUrl + "rangosMesas/getDetailsRangoMesas",
            config
          )
          .then(function(response) {
            if (response.data.response) {
              vm.listDetalles = response.data.result;

              vm.pantallaDetalle = true;
            } else {
              swal({
                title: vm.$t("accesoDenegado"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });

              vm.respuesta = false;
            }
            vm.loading.close();
          })
          .catch(function(error) {
            console.log(error);
          });
    }
  },
};
</script>
<style>
a li {
  color: #111;
}
.card {
  padding: 20px;
}
.sunday {
  color: rgb(128, 0, 0);
}
.fridaySaturday {
  color: rgb(0, 128, 64);
}
.div-export {
  margin-bottom: 10px;
}
th span {
  cursor: pointer;
}
.btnVolver {
  float: left; 
  color: #007BCE; 
  background-color: transparent; 
  border-color: #007BCE;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/VentasRangoMesas.vue